import { useEffect, useState } from 'react';

export const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(global?.document?.body?.offsetWidth);

  useEffect(() => {
    const onResize = () => {
      setWindowWidth(global?.document?.body?.offsetWidth);
    };

    onResize();

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);
  return windowWidth;
};

export default useWindowWidth;
